// Shared program-domain labels and recommended-action/stage helpers.
// Single source of truth so screens can't drift out of sync with each other.

export const DOMAIN_LABELS = { msk: "MSK", diabetes: "Diabetes Management", telehealth: "Virtual Care" };

// Diabetes' "Routine diabetes care-gap closure" action has no dedicated
// recommendedActions stage mapping in the enums catalog; it always targets
// the stage-2 (active care-gap) cohort.
const DIABETES_CARE_GAP_ACTION = "Routine diabetes care-gap closure";
const DIABETES_CARE_GAP_STAGE_ID = 2;

export function actionStages(enums, domain, action) {
  const mapping = enums.recommendedActions?.[domain] || {};
  const stages = Object.entries(mapping)
    .filter(([, value]) => value === action)
    .map(([stageId]) => enums.stages[domain].find((stage) => String(stage.id) === String(stageId)))
    .filter((stage) => stage?.id > 0)
    .filter(Boolean)
    .sort((a, b) => a.id - b.id);
  if (stages.length === 0 && domain === "diabetes" && action === DIABETES_CARE_GAP_ACTION) {
    const careGapStage = enums.stages.diabetes.find((stage) => stage.id === DIABETES_CARE_GAP_STAGE_ID);
    return careGapStage ? [careGapStage] : [];
  }
  return stages;
}

export function sortActionsByStage(enums, domain, rows = []) {
  return [...rows].sort((a, b) => {
    const aStages = actionStages(enums, domain, a.label);
    const bStages = actionStages(enums, domain, b.label);
    return (aStages[0]?.id ?? 999) - (bStages[0]?.id ?? 999) || a.label.localeCompare(b.label);
  });
}

// Mirrors the stage-2 fallback above for callers that build goal/action
// option lists directly from enums.recommendedActions rather than rows.
export function withDiabetesCareGapFallback(byAction, domain, selectedAction) {
  if (domain === "diabetes" && selectedAction === DIABETES_CARE_GAP_ACTION && !byAction.has(selectedAction)) {
    byAction.set(selectedAction, [DIABETES_CARE_GAP_STAGE_ID]);
  }
  return byAction;
}
